import FormatUtil from "../../utils/formatUtil";
export var AlarmLevel;
(function (AlarmLevel) {
    AlarmLevel[AlarmLevel["NoValue"] = 0] = "NoValue";
    AlarmLevel[AlarmLevel["OK"] = 1] = "OK";
    AlarmLevel[AlarmLevel["Warning"] = 2] = "Warning";
    AlarmLevel[AlarmLevel["Alarm"] = 3] = "Alarm";
    AlarmLevel[AlarmLevel["AboveMax"] = 4] = "AboveMax";
})(AlarmLevel || (AlarmLevel = {}));
export class ForecastResult {
    constructor() {
        this.minLimit = NaN;
        this.maxLimit = NaN;
        this.unom = NaN;
        this.alarmRatio = NaN;
        this.maxPercOfTime = NaN;
        this.percOfUnom = NaN;
        this.toString = () => {
            const fT = FormatUtil.formatTime, fNg4 = function (n) { return isNaN(n) ? "¤¤¤" : n.toPrecision(4); }, fN = function (n) { return isNaN(n) ? "¤¤¤" : (Math.round(n * 100) / 100).toString(); };
            return `Max lim: ${fN(this.maxLimit)}, ${fN(this.maxPercOfTime)} % of time
Min lim: ${fN(this.minLimit)}
Alarm ratio: ${fNg4(this.alarmRatio)}
Worst point: ${fT(this.worstPoint.time)} ${fNg4(this.worstPoint.value)}
% of unom: ${fNg4(this.percOfUnom)}, unom: ${fN(this.unom)}
`;
        };
    }
}
